// Copyright (c) 2022 by Move Closer.

import { mapModel, MappingConfig, MappingTypes } from '@movecloser/front-core'
import { PossibleOrderStatus } from '../../../contexts/orders/contracts/orders'
import { translateToCamelCase } from './statuses.adapter'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const orderAdapterMap: MappingConfig = {
  billingAddress: {
    type: MappingTypes.Function,
    value: (item) => item.billing_address ? mapModel(item.billing_address, orderAddressAdapterMap, false) : null
  },
  carrier: 'carrier',
  createdAt: 'created_at',
  id: 'number',
  paymentMethod: 'payment_method',
  products: {
    type: MappingTypes.Function,
    value: (item) => {
      return item.items.map((product: any) => {
        return {
          name: product.product_name,
          price: product.product_sale_price,
          sku: product.product_sku,
          quantity: product.quantity_ordered
        }
      })
    }
  },
  productsCost: {
    type: MappingTypes.Function,
    value: (item) => {
      let sum = 0
      item.items.forEach((product: any) => {
        sum = sum + product.product_sale_price.value * product.quantity_ordered
      })
      return sum
    }
  },
  productSkus: {
    type: MappingTypes.Function,
    value: (item) => {
      return item.items.map((product: any) => product.product_sku)
    }
  },
  shippingAddress: {
    type: MappingTypes.Function,
    value: (item) => item.shipping_address ? mapModel(item.shipping_address, orderAddressAdapterMap, false) : null
  },
  shippingCost: {
    type: MappingTypes.Function,
    value: (item) => {
      return item.total.shipping_handling.amount_including_tax.value
    }
  },
  status: {
    type: MappingTypes.Function,
    value: (item) => {
      return PossibleOrderStatus[item.status]
    }
  },
  statusCode: {
    type: MappingTypes.Function,
    value: (item) => {
      return item.status_code ? translateToCamelCase(item.status_code) : ''
    }
  },
  statusDetails: {
    type: MappingTypes.Function,
    value: () => {
      return 'Error'
    }
  },
  total: {
    type: MappingTypes.Function,
    value: (item) => {
      return {
        discounts: item.total.discounts,
        grandTotal: item.total.grand_total,
        shippingHandling: {
          amountIncludingTax: item.total.shipping_handling.amount_including_tax
        }
      }
    }
  },
  totalCost: {
    type: MappingTypes.Function,
    value: (item) => {
      return item.total.grand_total.value
    }
  },
  updatedAt: 'updated_at'
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const orderAddressAdapterMap: MappingConfig = {
  countryCode: 'country_code',
  firstName: 'firstname',
  lastName: 'lastname',
  middleName: 'middlename',
  postCode: 'postcode',
  regionId: 'region_id',
  vatId: 'vat_id'
}
